<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
				<!-- 	<div class="introBox">
						<span class="bTextOne" @click="$router.push({path:'/home/company',query:{type:'company'}})">公司简介</span>
						<div class="boxBottom bottomOne"></div>
					</div> -->
				<div class="introBox" @click="getData(item.id)" v-for="(item,index) in list" >
					<span class="bTextOne">{{item.columname}}</span>
					<div :class="['boxBottom',index == 0 ?'bottomOne':index % 2 == 0 ?'bottomTwo':'bottomThree'] "></div>
				</div>
				</el-card>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-form ref="form" :model="form" label-width="120px" >
						<h4>详细内容</h4>
						<el-form-item  style="margin-top: 40px;">
							<editor v-model="form.detail" :isClear="isClear"></editor>
						</el-form-item>
						<div class="line"></div>
						<el-form-item label="描述" style="margin-top: 20px;">
							<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容" v-model="form.desc">
							</el-input>
						</el-form-item>
						<el-form-item>
							<input  type="button" @click="onSubmit" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import E from "wangeditor";
	import qs from 'qs'
	import Editor from '../../../components/tinymce.vue'
	export default {
		components: {
			Editor
		},
		data() {
			return {
				list:[],
				form: {
					desc:'',
					detail:'',
					id:''
				},
				isClear: false,
			}
		},
		mounted() {
		},
		created() {
			this.getData(this.$route.query.id)
			this.getDatail()
		},
		methods: {
			getData(id){
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/show/get',
					params: {
 
						cid:id
					},
				}).then((res) => {
					if (res.data.status == 200) {
						if(res.data.data.childColumc == ''){
							this.$router.push({
								path:'/home/company',
								query:{
									id:id
								}
							})
						}else{
							this.list = res.data.data.childColumc
						}
						
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			onSubmit() {
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/show/update',
					data: {
						 
						cid:this.$route.query.id,
						id:this.form.id,
						content:this.form.detail,
						brief:this.form.desc
					},
				}).then((res) => {
					if (res.data.status == 200) {
						obj.$message.success('修改成功')
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			getDatail(){
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/show/get',
					params: {
						 
						cid:this.$route.query.id
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.form.detail = res.data.data.show.content
						this.form.desc = res.data.data.show.brief
						this.form.id = res.data.data.show.id
					} else {
						obj.$message.error(res.data.message)
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.introBox {
		width: 319px;
		height: 127px;
		background: #FFFFFF;
		box-shadow: -1px -4px 6px 1px rgba(0, 0, 0, 0.17);
		border-radius: 15px;
		float: left;
		margin-right: 35px;
		margin-bottom: 20px;
		position: relative;
		text-align: center;
		cursor: pointer;
	}

	.boxBottom {
		width: 319px;
		height: 36px;
		border-radius: 0px 0px 15px 15px;
		position: absolute;
		bottom: 0;
	}

	.bottomOne {
		background: #F3AC9C;
	}

	.bottomTwo {
		background: #8896F6;
	}

	.bottomThree {
		background: #76B67E;
	}

	.bTextOne {
		width: 83px;
		height: 19px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 24px;
		color: #F3AC9C;
		display: block;
		margin: 0 auto;
		padding-top: 30px;
	}

	.bTextTwo {
		width: 83px;
		height: 19px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 24px;
		color: #8896F6;
		display: block;
		margin: 0 auto;
		padding-top: 30px;
	}

	.bTextThree {
		width: 83px;
		height: 19px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 24px;
		color: #76B67E;
		display: block;
		margin: 0 auto;
		padding-top: 30px;
	}

	.uploadBtn {
		width: 146px;
		height: 33px;
		background: #FFFFFF;
		box-shadow: 4px 4px 6px 1px rgba(0, 0, 0, 0.13);
		border-radius: 3px;
		border: 1px solid #FFFFFF;
		color: #5EB4EB;
	}

	.uploadBtn:hover {
		color: #FFFFFF;
		background: #5EB4EB;
		border: 1px solid #5EB4EB;
	}

	/deep/ .el-upload__tip {
		float: left;
		width: 219px;
		height: 19px;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.4;
	}
		.submit {
		width: 91px;
		height: 33px;
			background: #8896F6;
			box-shadow: 3px 2px 7px 1px rgba(0, 0, 0, 0.34);
			border-radius: 5px;
			border: 1px solid #8896F6;
			color: #FFFFFF;
			float: right;
		}
</style>



// WEBPACK FOOTER //
// src/views/content/introduction/about.vue